import type { Strings } from "../i18n/strings";
import type { Lang } from "../lib/types";
import { LEGAL, type LegalKind } from "../content/legal";

interface Props {
  t: Strings;
  lang: Lang;
  kind: LegalKind;
  onBack: () => void;
}

// 개인정보 처리방침 / 이용약관 (설정에서 진입). 긴 본문 스크롤. 별도 디자인 없이 다크 톤 가독성.
export default function Legal({ t, lang, kind, onBack }: Props) {
  const doc = LEGAL[lang][kind];
  return (
    <div className="screen legal">
      <div className="rep-header">
        <button className="navbtn" onClick={onBack}>
          ← {t.back}
        </button>
      </div>
      <div className="legal-scroll">
        <h1 className="legal-title">{doc.title}</h1>
        <p className="legal-effective">{doc.effective}</p>
        {doc.intro.map((p, i) => (
          <p key={`intro-${i}`} className="legal-p">
            {p}
          </p>
        ))}
        {doc.sections.map((s, i) => (
          <section key={i} className="legal-section">
            <h2 className="legal-h">{s.h}</h2>
            {s.body.map((line, j) =>
              line.startsWith("· ") ? (
                <p key={j} className="legal-bullet">
                  {line.slice(2)}
                </p>
              ) : (
                <p key={j} className="legal-p">
                  {line}
                </p>
              ),
            )}
          </section>
        ))}
      </div>
    </div>
  );
}
